import { useAuth } from "#auth.tsx";
import { StaffDialog } from "#order-dialog.tsx";
import { PasskeySettings } from "#passkey-settings.tsx";
import { useLanguage } from "#i18n.tsx";

/** Credential controls for direct sessions and expiry details for shift sessions. */
export function AccountDevicesDialog({ close }: { readonly close: () => void }) {
  const { api, state } = useAuth();
  const { language, t } = useLanguage();
  if (state.kind !== "authenticated") return null;

  return (
    <StaffDialog
      title={t("account.title")}
      close={close}
      closeLabel={t("account.close")}
    >
      <div className="dialog-body account-devices">
        <p className="muted">
          {t("account.signedIn")} <strong>{state.username}</strong> ({state.role}).
        </p>
        {api.supportsPasskeys && state.sessionKind === "direct" && (
          <PasskeySettings />
        )}
        {state.sessionKind === "kitchen-shift" && (
          <section className="settings-card">
            <h2>{t("account.kitchenShift")}</h2>
            <p>
              {t("account.sessionEnds")} {" "}
              <strong>
                {new Date(state.shiftExpiresAt).toLocaleTimeString(language, {
                  hour: "numeric",
                  minute: "2-digit",
                })}
              </strong>
              . {t("account.newQr")}
            </p>
            <p className="muted">{t("account.credentialsLocked")}</p>
          </section>
        )}
      </div>
    </StaffDialog>
  );
}
